<div class="sticky-header" #header>
  <dxo-top-nav
    logoImg="/assets/images/symetra_logo.svg"
    [logoText]="logoText"
    [username]="userFullName"
    [logoText]="logoText"
    [accountMenuItems]="accountMenuItems"
    [secondaryNavRoutes]="secondaryNavRoutes"
    [underSecondaryNavRoutes]="accountMenuItems"
    [dxoDataset]="{ selector: '.user > span', data: { e2e: 'Account menu' } }"
  >
  </dxo-top-nav>
</div>
<main #main>
  <router-outlet></router-outlet>
</main>
<app-portal-timeout-modal [countdownTimeSeconds]="initialCountdown" (logout)="logout()"></app-portal-timeout-modal>
<app-footer></app-footer>
